import { Component } from 'react';

export default class MaximumMortgageIframeComponent extends Component {
  componentDidMount() {
    if (window.iFrameResize) {
      window.iFrameResize({
        heightCalculationMethod: 'max',
      }, '#maxhypotheekIframe');
    } else {
      window.onload = () => window.iFrameResize({
        heightCalculationMethod: 'max',
      }, '#maxhypotheekIframe');
    }
  }

  render() {
    const style = {
      width: '100%',
      border: 0,
    };

    return (
      <iframe
        id="maxhypotheekIframe"
        src="https://79f75d3e-1e33-40d9-8125-1f712e1f9f39.tools.hypotheekbond.nl/maxmortgage/landing"
        style={style}
        scrolling="no"
      />
    );
  }
}

